export default __webpack_public_path__ + "static/media/Comunicação.57bdb122.jpg";